import * as yup from "yup";

export const TraceIpSchema = (t) =>
  yup.object().shape({
    ipOrDomain: yup.string().required(t.rules.ipOrDomain.required),
    showByCountries: yup.bool().required()
  });
